import config from 'config';
import { THttpErrorResp } from './index.types';
import http from './http';

export const httpTimeout = <T>(
    request: RequestInfo,
): Promise<T | undefined | THttpErrorResp | string> => {
    return Promise.race([
        (() => {
            return new Promise<THttpErrorResp>((resolve, reject) => {
                setTimeout(() => {
                    reject({ message: 'Network timeout reached' });
                }, config.fetch.timeout);
            });
        })().then((resp) => resp),
        http<T>(request).then((response) =>
            response.parsedBody ? response.parsedBody : undefined,
        ),
    ]).catch((e: THttpErrorResp) => {
        return Promise.reject(config.parseHttpErrors(e));
    });
};

export default httpTimeout;
